import { render } from "./AfterConfirmationAcceptanceScreen.vue?vue&type=template&id=62a7894e&ts=true"
import script from "./AfterConfirmationAcceptanceScreen.vue?vue&type=script&lang=ts"
export * from "./AfterConfirmationAcceptanceScreen.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__